const videoSource14 = [
  {
    id: "video16",
    src: require("./2_7.mp4"),
  },
  {
    id: "video17",
    src: require("./2_8.mp4"),
  },
  {
    id: "video18",
    src: require("./2_9.mp4"),
  },
];

export default videoSource14;
